// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".E--OAgobjKGflA {\n  margin: 1em 0;\n}\n.E--OAgobjKGflA ._8sx_-0e1RnMsYQ {\n  font-size: 1em;\n  color: #172B4D;\n}\n.E--OAgobjKGflA ._8sx_-0e1RnMsYQ ._1QfnLy4ockJOtG {\n  color: #8993A4;\n}\n@media only screen and (max-width: 750px) {\n  .OYXjfuDrGJr4TV {\n    display: none;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkoutEnterprise": "E--OAgobjKGflA",
	"content": "_8sx_-0e1RnMsYQ",
	"enterpriseLink": "_1QfnLy4ockJOtG",
	"hideOnSmallScreens": "OYXjfuDrGJr4TV"
};
export default ___CSS_LOADER_EXPORT___;
